import { render, staticRenderFns } from "./AtTemplate.vue?vue&type=template&id=d8a72552"
var script = {}
import style0 from "./At.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports